import type { FC } from 'react';
import { InlineAlert } from '@reverse-hr/design-system';
import { ALERT_VARIANTS_BY_TYPE } from '@components/ShareLinkModal/_constants/ShareLinkModal.constants';
import type {
  TAlertDetail,
  TShareLinkModalAlertProps,
} from '@components/ShareLinkModal/ShareLinkModal.types';

export const ShareLinkModalAlert: FC<TShareLinkModalAlertProps> = props => {
  const { alertDetail, setAlertDetail } = props;

  return (
    <div className="rev-o-container rev-o-container--full">
      <div className="rev-o-grid">
        {alertDetail.visible ? (
          <div className="rev-o-col-12 rev-u-px-16 rev-u-mt-24">
            <InlineAlert
              icon={alertDetail.icon}
              isClosable
              onClose={() =>
                setAlertDetail((prev: TAlertDetail) => ({
                  ...prev,
                  visible: false,
                }))
              }
              title={alertDetail.children}
              variant={ALERT_VARIANTS_BY_TYPE[alertDetail.type]}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
